import { render, staticRenderFns } from "./DocumentTypesAddition.vue?vue&type=template&id=1c3fcdba&scoped=true&"
import script from "./DocumentTypesAddition.vue?vue&type=script&setup=true&lang=js&"
export * from "./DocumentTypesAddition.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DocumentTypesAddition.vue?vue&type=style&index=0&id=1c3fcdba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3fcdba",
  null
  
)

export default component.exports